import validate from "/Users/mile/Projekti/ivanobazeni.hr/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45global from "/Users/mile/Projekti/nuxt-base/middleware/app.global.js";
import guards_45global from "/Users/mile/Projekti/nuxt-base/middleware/guards.global.js";
import redirect_45global from "/Users/mile/Projekti/nuxt-base/middleware/redirect.global.js";
import manifest_45route_45rule from "/Users/mile/Projekti/ivanobazeni.hr/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  app_45global,
  guards_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}